import dayjs from "dayjs";
import { IBuildingFromTemplateAdapter } from "../../components/property-form/septions/property-steps/buildings-step/hooks/useUpTemplateBuilding/models/upTemplate.model";
import { GetCurrencyType } from "./to-client/prepareExtrasArray";
import { IPropertyForm } from "../../components/property-form/util/schemas/property-schema/propertySchema";

const patchProjectTemplateAdapter = (state: IBuildingFromTemplateAdapter[]) => {
  return {
    building: getBuilding(state) as IPropertyForm["building"]
  };
};
export default patchProjectTemplateAdapter;

const getBuilding = (state: IBuildingFromTemplateAdapter[]) => {
  return state.map((building, i) => ({
    id: window.crypto.randomUUID(),
    name: building.nameBuilding,
    dateDelivery: dayjs(building.deliveryDate).format("YYYY-MM-DD") ?? "",
    isNew: true,
    isDelete: false,
    unitsQuantity: "",
    isCaptured: i == 0 ? true : false,
    units: building.units.map(unit => ({
      id: window.crypto.randomUUID(),
      name: unit.name,
      price: unit.price,
      currency: GetCurrencyType(unit.currency == "RD" ? "1" : "2"),
      bedrooms: unit.bedrooms || "",
      bathrooms: unit.bathrooms || "",
      halfBathrooms: unit.half_bathrooms || "0",
      parkingSpots: unit.parking || "",
      levelFloor: unit.level || "",
      totalFloor: "",
      metersConstruction: unit.construction_area || "",
      metersLand: unit.land_area || "",
      isNew: true,
      isDelete: false,
      maintenanceFee: "",
      maintenanceCurrency: [],
      features: [],
      totalCommission: "",
      commissionGuaranteed: "",
      characteristics_frames_property: [],
      characteristics_closets_property: [],
      characteristics_door_property: [],
      characteristics_roof_form_property: [],
      characteristics_windows_property: [],
      characteristics_cabinets_property: [],
      characteristics_floors_property: [],
      characteristics_type_house_property: [],
      characteristics_type_roof_property: []
    }))
  })) as any[];
};
